import { render, staticRenderFns } from "./PlayControllerVideo.vue?vue&type=template&id=28d6e7e4&scoped=true"
import script from "./PlayControllerVideo.vue?vue&type=script&lang=js"
export * from "./PlayControllerVideo.vue?vue&type=script&lang=js"
import style0 from "./PlayControllerVideo.vue?vue&type=style&index=0&id=28d6e7e4&prod&scoped=true&lang=css"
import style1 from "./PlayControllerVideo.vue?vue&type=style&index=1&id=28d6e7e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d6e7e4",
  null
  
)

export default component.exports